<template>
    <div v-if="loaded">
        <rkm-area title="Dados da origem">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Unidade"
                        v-model="transferencia.origem.unidadeNomeFantasia"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Local de atendimento"
                        v-model="transferencia.origem.infraestruturaNome"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Setor"
                        v-model="transferencia.origem.setorNome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Materiais">
            <rkm-table
                :items="transferencia.itens"
                :fields="[
                    { key: 'materialDescricao', label: 'Material', sortable: true },
                    { key: 'quantidade', label: 'Quantidade', sortable: true },
                ]"
                hide-filters
                hide-pagination
            />
        </rkm-area>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            transferencia: this.getConectaSusRepository('almoxarifado.transferencia'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        transferencia: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.transferencia.getTransferenciaRecebida(this.id)
                .then(({ data }) => {

                    this.transferencia = data
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        accept() {

            const onConfirm = async () => {

                this.setLoading()

                this.repositories.transferencia.accept(this.id)
                    .then(() => this.$emit('save'))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showConfirmation('Deseja realmente aceitar esta transferência?', onConfirm)
        },
        reject() {

            const onConfirm = async () => {

                this.setLoading()

                this.repositories.transferencia.reject(this.id)
                    .then(() => this.$emit('save'))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showConfirmation('Deseja realmente recusar esta transferência?', onConfirm)
        }
    },
    mixins: [repository, error],
    props: {
        id: { type: Number, required: true },
    },
}
</script>